export class AudioPlayer extends EventTarget {
    constructor(url) {
        super()
        this.audio = null
        this.url = url
        this.loading = false
    }

    handleClick() {

        if (this.loading) {
            return
        }

        if (!this.audio) {
            this.audio = new Audio(this.url)
            this.addListeners()
            this.audio.load()
            return
        }

        if (this.audio.paused) {
            this.audio.play()
            return
        }

        this.audio.pause()
    }

    eventDetails() {
        return { detail: { timestamp: Date.now() } }
    }

    addListeners() {
        this.audio.addEventListener('loadstart', () => {
            this.loading = true
            const event = new CustomEvent('loading', this.eventDetails())
            this.dispatchEvent(event)
        })
        this.audio.addEventListener('canplay', () => {
            this.loading = false
            this.audio.play()
        })
        this.audio.addEventListener('play', () => {
            const event = new CustomEvent('playing', this.eventDetails())
            this.dispatchEvent(event)
        })
        this.audio.addEventListener('pause', () => {
            const event = new CustomEvent('paused', this.eventDetails())
            this.dispatchEvent(event)
        })
        this.audio.addEventListener('ended', () => {
            const event = new CustomEvent('ended', this.eventDetails())
            this.dispatchEvent(event)
        })
    }

}
